/*
 * @FileName       : tenants.actions.ts
 * @Version        : 1.0
 * @DateOfCreation : 04/21/2020
 * @Author         : $u^^!t @ FFF Enterprises
 * @Dependencies   : N/A
 * @Description    : Action class for reports.
 *
 * Copyright (c) 2020, FFF Enterprises. All rights reserved.
 */

import { action } from 'typesafe-actions';
import { TENANTS } from '../constants/actions';
import { TenantsFilter, TenantsList } from '../models/tenants/tenants';
import { ResultSet } from '../models/common/result.set';

export const getTenantList = (data: TenantsFilter) => action(TENANTS.LIST, data);
export const successTenantsList = (data: ResultSet<TenantsList>) => action(TENANTS.LIST_RESPONSE, data);

export const getTenantsDetails = (data: TenantsFilter) => action(TENANTS.DETAILS.DETAIL_LIST, data);
export const successTenantsDetails = (data: ResultSet<TenantsList>) =>
	action(TENANTS.DETAILS.DETAIL_LIST_RESPONSE, data);

export const clearTenantsList = (reset: boolean = false) => action(TENANTS.CLEAR_TENANTS_LIST, reset);

export const getTenantBasicInfo = (data: TenantsFilter) => action(TENANTS.DETAILS.BASIC_INFO_REQUEST, data);
export const successTenantBasicInfo = (data: ResultSet<TenantsList>) =>
	action(TENANTS.DETAILS.BASIC_INFO_RESPONSE, data);

export const getTenantAdditionalInfo = (data: TenantsFilter) => action(TENANTS.DETAILS.ADDITIONAL_INFO_REQUEST, data);
export const setTenantAdditionalInfo = (data: ResultSet<TenantsList>) =>
	action(TENANTS.DETAILS.ADDITIONAL_INFO_RESPONSE, data);

export const getNotificationActivity = (customerId: string) =>
	action(TENANTS.DETAILS.NOTIFICATION_ACTIVITY_REQUEST, customerId);
export const setNotificationActivity = (data: any) => action(TENANTS.DETAILS.NOTIFICATION_ACTIVITY_RESPONSE, data);
export const getNotificationMessage = (messageId: string) =>
	action(TENANTS.DETAILS.NOTIFICATION_MESSAGE_REQUEST, messageId);
export const setNotificationMessage = (data: any) => action(TENANTS.DETAILS.NOTIFICATION_MESSAGE_RESPONSE, data);

export const getTenant = (data: any) => action(TENANTS.GET_TENANT, data);

export const syncCustomer = (payload: any) => action(TENANTS.SYNC, payload);

export const updateCustomer = (payload: any) => action(TENANTS.UPDATE_TENANT, payload);
export const getTenantProducts = (data: any) => action(TENANTS.DETAILS.GET_PRODUCTS, data);
export const setTenantProducts = (data: any) => action(TENANTS.DETAILS.SET_PRODUCTS, data);

export const createCustomerProduct = (data: any) => action(TENANTS.DETAILS.CREATE_CUSTOMER_PRODUCT, data);
export const getCreditCardEligibleProductsForCustomer = (data: any) =>
	action(TENANTS.GET_CREDIT_CARD_ELIGIBLE_PRODUCTS_FOR_CUSTOMER, data);
export const setCreditCardEligibleProductsForCustomer = (data: any) =>
	action(TENANTS.SET_CREDIT_CARD_ELIGIBLE_PRODUCTS_FOR_CUSTOMER, data);

export const getClassOfTradeOptions   = () => action(TENANTS.GET_CLASS_OF_TRADE_OPTIONS);
export const setClassOfTradeOptions   = (data: any) => action(TENANTS.SET_CLASS_OF_TRADE_OPTIONS, data);
export const getFacilityTypeOptions   = () => action(TENANTS.GET_FACILITY_TYPE_OPTIONS);
export const setFacilityTypeOptions   = (data: any) => action(TENANTS.SET_FACILITY_TYPE_OPTIONS, data);